// Waggzy — JS mínimo (o carrinho usa submissão de formulário normal, sem AJAX,
// para manter o tema simples e fiável).
document.addEventListener('DOMContentLoaded', function () {
  console.log('Waggzy theme loaded');
});
